import { TouchableOpacity } from 'react-native'

import { DS } from '../../design-system'
import { styles } from './styles'

export const Header = ({
  isDailyDiscussionsEnabled,
  onBackPress,
  addNewResponse
}: {
  isDailyDiscussionsEnabled: boolean
  onBackPress: () => void
  addNewResponse: () => void
}) => {
  return (
    <DS.Frame row bg="Brand/Cream" justifyContent="space-between" alignItems="center" style={styles.headerContainer}>
      <TouchableOpacity onPress={onBackPress}>
        <DS.Icon name="Arrow---left" color="Global/Black" size={24} />
      </TouchableOpacity>
      <DS.Text variant="Body Medium/Medium" color="Global/Black">
        Discussion
      </DS.Text>
      {isDailyDiscussionsEnabled ? (
        <TouchableOpacity onPress={addNewResponse}>
          <DS.Icon name="Plus--enclosed" color="Global/Black" size={24} />
        </TouchableOpacity>
      ) : (
        <DS.Frame />
      )}
    </DS.Frame>
  )
}
